const config = {
  // API_URL: '/api-delivery/v1',
  API_URL: 'https://feature-master-lk-ap-site.k1.diverting.ru/api-delivery/v1',
  VERSION: '0.12.3',
  SECRET_KEY: 'D1Ph59fKY^5',
};

export default config;
